<div class="company-accounts">
  <div class="company-accounts-table">
    <mat-table
      matSort
      [dataSource]="dataSource"
      [matSortActive]="requestParams.sort"
      [matSortDirection]="requestParams.order"
      [@animateStaggerRemondis]="dataSource && dataSource.length"
      [@.disabled]="disableAnimations">

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'COMPANY_ACCOUNTS.NAME' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let account"> {{account.name}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="surname">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'COMPANY_ACCOUNTS.SURNAME' | translate}}
        </mat-header-cell>
        <mat-cell *matCellDef="let account"> {{account.surname}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'COMPANY_ACCOUNTS.EMAIL' | translate}}
        </mat-header-cell>
        <mat-cell *matCellDef="let account"> {{account.email}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="phone">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'COMPANY_ACCOUNTS.PHONE' | translate}}
        </mat-header-cell>
        <mat-cell *matCellDef="let account"> {{account.phone}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'COMPANY_ACCOUNTS.STATUS' | translate}}
        </mat-header-cell>
        <mat-cell *matCellDef="let account">
          <mat-icon [ngClass]="account.active && 'green-icon'">
            {{account.active ? 'check' : 'close'}}
          </mat-icon>
        </mat-cell>
      </ng-container>


      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row
        class="company-account-row"
        *matRowDef="let account; columns: displayedColumns;"
        [@animateRemondis]="{value:'*',params:{y:'100%'}}"
        [id]="account.uuid"
        (click)="viewCompanyAccount(account.uuid)">
      </mat-row>
    </mat-table>

    <h4 class="no-data" *ngIf="totalCount === 0">
      {{'SHARED.NO_DATA' | translate}}
    </h4>

    <div class="paginator-container" [ngClass]="{'no-pagination': !totalCount}">
      <mat-paginator
        *ngIf="totalCount"
        (page)="pageChange($event)"
        [pageSize]="requestParams.limit"
        [length]="totalCount"
        class="paginator-holder"
      ></mat-paginator>
    </div>
    <div class="button-add-wrapper">
      <button mat-raised-button color="primary"
              [@animate]="{value:'*', params:{delay:'300ms',scale:'.2'}}"
              (click)="addCompanyAccount()"
              [attr.data-cy]="'addCompanyAccount'">
        {{ 'COMPANY_ACCOUNTS.TITLE_ADD' | translate }}
      </button>
    </div>
  </div>
</div>
